<template>
    <div class="h-footer">
        <div class="footer-container">
            <div class="footer-info">
                <ul class="footer-nav">
                    <li class="nav-item">
                        <p class="item-title">新闻中心</p>
                        <div class="item-wrapper">
                            <p @click="goNext('news', 'dynamic')">机构动态</p>
                            <p @click="goNext('news', 'info')">行业资讯</p>
                            <p @click="goNext('news', 'party')">党建要闻</p>
                            <p @click="goNext('news', 'story')">视频故事</p>
                        </div>
                    </li>
                    <li class="nav-item">
                        <p class="item-title">公益项目</p>
                        <div class="item-wrapper">
                            <p @click="goNextHandle(item)" v-for="(item, i) in commonwealData" :key="i">{{item.name}}</p>
                        </div>
                    </li>
                    <li class="nav-item">
                        <p class="item-title">信息披露</p>
                        <div class="item-wrapper">
                            <p @click="goNext('info', 'year')">年度报告</p>
                            <p @click="goNext('info', 'audit')">审计报告</p>
                            <p @click="goNext('info', 'finance')">财务公示</p>
                            <p @click="goNext('info', 'rules')">规章制度</p>
                            <p @click="goNext('info', 'donation')">捐赠情况</p>
                        </div>
                    </li>
                    <li class="nav-item">
                        <p class="item-title">关于我们</p>
                        <div class="item-wrapper">
                            <p @click="goNext('about', 'Introduction')">基金会介绍</p>
                            <p @click="goNext('about', 'Organization')">组织架构</p>
                            <p @click="goNext('about', 'Chronicle')">大事记</p>
                            <p @click="goNext('about', 'Honour')">所获荣誉</p>
                            <p @click="goNext('about', 'Contact')">联系方式</p>
                        </div>
                    </li>
                    <li class="nav-item">
                        <p class="item-title">成为志愿者</p>
                        <div class="item-wrapper">
                            <p @click="goNext('volunter', 'recruit')">志愿者招募</p>
                            <p @click="goNext('volunter', 'activity')">志愿者活动</p>
                            <p @click="goNext('volunter', 'story')">志愿者故事</p>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="footer-address">
                            <img class="footer-logo" src="../../static/assets/image/yt-logo-footer.png" />
                            <p class="found-account">上海九方公益基金会账户</p>
                            <ul class="found-detail">
                                <li>
                                    <label>银行账号：</label>
                                    <p>1219 2200 1410 502</p>
                                </li>
                                <li>
                                    <label>户名：</label>
                                    <p>上海九方公益基金会</p>
                                </li>
                                <li>
                                    <label>开户银行：</label>
                                    <p>招商银行上海常德支行</p>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <!-- <div class="footer-address">
                    <img class="footer-logo" src="../../static/assets/image/yt-logo-footer.png" />
                    <p class="found-account">上海九方公益基金会账户</p>
                    <ul class="found-detail">
                        <li>
                            <label>银行账号：</label>
                            <p>1219 2200 1410 502</p>
                        </li>
                        <li>
                            <label>户名：</label>
                            <p>上海九方公益基金会</p>
                        </li>
                        <li>
                            <label>开户银行：</label>
                            <p>招商银行上海常德支行</p>
                        </li>
                    </ul>
                </div> -->
            </div>
            <ul class="footer-link">
                <li>友情链接：</li>
                <li v-for="(obj, inx) in footerLink" :key="inx" @click="handleLink(obj)"><label>{{obj.title}}</label><span v-show="inx !== footerLink.length-1">|</span></li>
            </ul>
        </div>

        <div class="footer-expand">
            <span>备案/许可证编号：<a class="footer-gov" href="https://beian.miit.gov.cn" target="_blank">沪ICP备19039698号-4</a> www.jfpwf.org.cn Copyright @ 2025 版权所有：上海九方公益基金会</span>

        </div>
         <div class="footer-expand2">
            <img
                src="../../static/assets/beian.png"
                class="footer-beian"
            />
            <span><a class="footer-gov" href="https://beian.mps.gov.cn/#/query/webSearch?code=31011802005626"  target="_blank">沪公网安备31011802005626号</a></span>
        </div>
    </div>
</template>
<script>
import config from '@/util/config';

export default {
    data() {
        return {
            routeName: '',
            footerLink: [{
                title: '基金会中心网',
                link: 'http://www.foundationcenter.org.cn/'
            }, {
                title: '上海社会组织网',
                link: 'http://mzj.sh.gov.cn/shzz/index.html'
            }, {
                title: '腾讯公益',
                link: 'https://gongyi.qq.com/'
            }, {
                title: '联劝公益基金会',
                link: 'https://www.lianquan.org.cn/'
            }]
        };
    },
    props: {
        navType: {
            type: String,
            default: 'home'
        },
        commonwealData: {
            type: Array
        }
    },
    methods: {
        goNext(page, route) {
            if (page === 'volunter' && route === 'recruit') {
                window.open('https://f.lingxi360.com/f?fid=nZIAndBVV&utm_bccid=LXEhzRBjbp_l', '_blank');
                return;
            }
            this.$store.commit('common/SET_HAS_THEME', true);
            if (
                (this.navType === 'center' && page === 'news') ||
                (this.navType === 'disclosure' && page === 'info') ||
                (this.navType === 'volunter' && page === 'volunter') ||
                (this.navType === 'intro' && page === 'about')
            ) {
                if (this.$route.name === route) {
                    return;
                }
                this.$emit('handleRouteChange', route);
                this.$router.push({ name: route });
                return;
            }
            let url;
            if (page === 'home') {
                url = `${config.getUrl()}/index.html`;
            } else {
                url = route ? `${config.getUrl()}/${page}.html#/${route}` : `${config.getUrl()}/${page}.html`;
            }
            window.location.href = url;
        },
        goNextHandle(item) {
            this.$store.commit('common/SET_HAS_THEME', true);
            if (this.navType === 'project') {
                this.$store.commit('home/SET_WEAL_INFO', item);
                this.$emit('handleRouteChange', 'aid');
                // eslint-disable-next-line
                document.documentElement.scrollTop = document.body.scrollTop = 0;
                if (this.routeName) return;
                this.$router.push({ name: 'aid' });
                this.routeName = 'aid';
                return;
            }
            this.$store.commit('home/SET_WEAL_INFO', item);
            const url = `${config.getUrl()}/commonweal.html#/aid`;
            window.location.href = url;
        },
        handleLink(item) {
            window.open(item.link, '_blank');
        }
    },
    created() {
        if (this.$route.name === 'aid') {
            this.routeName = this.$route.name;
        }
    }
};
</script>
<style lang="scss" scoped>
.footer-beian {
    margin-right: -10px;
    margin-bottom: 4px;
    // width: 16px;
    // height: 18px;
}
.h-footer {
    background: #192038;
    .footer-container {
        margin: 0 auto;
        padding-top: 64px;
        width: 1180px;
        text-align: left;
        .footer-info {
            display: flex;
            flex-direction: row;
            // justify-content: space-between;
            // height: 230px;
        }
        .footer-nav {
            width: 100%;
            .nav-item {
                display: inline-block;
                margin-right: 9%;
                vertical-align: top;
                overflow: hidden;
                &:last-child {
                    float: right;
                    margin-right: 0;
                }
            }
            .item-title {
                font-size: 18px;
                font-weight: 400;
                color: #FFFFFF;
            }
            .item-wrapper {
                margin-top: 26px;
                width: 90px;
                >p {
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                    padding: 8px 0;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.5);
                    line-height: 20px;
                    cursor: pointer;
                }
                >p:hover {
                    color: #fff;
                }
            }
        }
        .footer-address {
            .footer-logo {
                width: 170px;
            }
            .found-account {
                padding: 16px 0 8px;
                font-size: 16px;
                font-weight: 400;
                color: #fff;
            }
            .found-detail {
                >li {
                    padding: 8px 0;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.5);
                    line-height: 20px;
                }
            }
            .detail-tel {
                margin-top: 15px;
            }
            .detail-tel, .detail-address {
                font-size: 16px;
                font-weight: 400;
                color: #949494;
                line-height: 24px;
            }
        }
        .footer-link {
            margin-top: 40px;
            padding: 20px 0;
            border-top: 1px solid rgba(255, 255, 255, 0.06);
            color: rgba(255, 255, 255, 0.5);
            text-align: center;
            font-size: 0;
            >li {
                display: inline-block;
                font-size: 14px;
                span {
                    margin: 0 8px;
                }
            }
            >li:hover {
                label {
                   color: #fff;
                   cursor: pointer;
                }
            }
        }
    }
    .footer-expand {
        padding: 20px 0;
        background: rgba(255, 255, 255, 0.04);
        text-align: center;
        img {
            width: 20px;
            vertical-align: middle;
        }
        span {
            margin-left: 14px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            line-height: 14px;
            vertical-align: middle;
            .footer-gov {
                color: rgba(255, 255, 255, 0.5);
                text-decoration:none;
            }
            .footer-gov:hover {
                color: #fff;
            }
        }
    }
    .footer-expand2 {
        // padding: 20px 0;
        padding-bottom: 20px;
        padding-top: -5px;
        background: rgba(255, 255, 255, 0.04);
        text-align: center;
        img {
            width: 20px;
            vertical-align: middle;
        }
        span {
            margin-left: 14px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            line-height: 14px;
            vertical-align: middle;
            .footer-gov {
                color: rgba(255, 255, 255, 0.5);
                text-decoration:none;
            }
            .footer-gov:hover {
                color: #fff;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/h-footer.vue